import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';
import { Extras } from './Extras';
import { ExtrasWrapper } from './ExtrasSection.styles';
import { usePackageConfiguration } from '../../contexts';
import { toRoomExtraEntries } from '../../helpers/extrasEntries';

export const ExtrasSection = () => {
  const { availableExtras = [] } = usePackageConfiguration();
  const { watch, setValue } = useFormContext();

  const selectedExtras = watch('extras') || [];

  useEffect(() => {
    if (!availableExtras) {
      return;
    }
    // Prevents removing selected options when return to this step
    if (selectedExtras.length === 0) {
      setValue('extras', toRoomExtraEntries(availableExtras));
    }
  }, []);

  return (
    <ExtrasWrapper>
      <Extras extras={availableExtras} selectedExtras={selectedExtras} />
    </ExtrasWrapper>
  );
};
